module.exports = __webpack_public_path__ + "img/3-1.0851c246.gif";